import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Contractdate } from './contractdate.model';
import { ContractdateService } from './contractdate.service';
@Injectable()
export class ContractdatePopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private contractdateService: ContractdateService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.contractdateService.find(id).subscribe((contractdate) => {
                contractdate.realDate = this.datePipe
                    .transform(contractdate.realDate, 'yyyy-MM-ddThh:mm');
                contractdate.originalDate = this.datePipe
                    .transform(contractdate.originalDate, 'yyyy-MM-ddThh:mm');
                contractdate.evasiveDate = this.datePipe
                    .transform(contractdate.evasiveDate, 'yyyy-MM-ddThh:mm');
                this.contractdateModalRef(component, contractdate);
            });
        } else {
            return this.contractdateModalRef(component, new Contractdate());
        }
    }

    contractdateModalRef(component: Component, contractdate: Contractdate): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.contractdate = contractdate;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate-popup.service.ts